import React from "react";

function DarkBlueCircleGauge({fill}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
      <path d="M7.12073 18.3538C11.0535 20.6244 16.0824 19.2768 18.3531 15.3438C20.6237 11.4109 19.2763 6.38197 15.3436 4.11138C11.4108 1.8408 6.38191 3.18839 4.11123 7.12132C1.84056 11.0542 3.18795 16.0832 7.12073 18.3538Z" fill="#01B4DE" stroke="#262627" stroke-width="2"/>
    </svg>
  )
}

export default DarkBlueCircleGauge;
